module.exports = __webpack_public_path__ + "1_0_60/img/env-2.d855b519.png";